import React from "react";
import { View, StyleSheet } from "react-native";
import {
  useNavigation,
  CommonActions,
  type NavigationProp,
} from "@react-navigation/native";
import {
  QuestionLayout,
  SquareOptionButton,
} from "@src/packages/medical-history/components";
import { useTranslations } from "@src/packages/i18n";
import { useFamilyHistory } from "../FamilyHistoryContext";
import type { FamilyHistoryStackParamList } from "../FamilyHistoryNavigator";
import { ANCESTRY_OPTIONS, type AncestryEnum } from "../options";

export function EthnicityScreen() {
  const t = useTranslations();
  const { state, updateState } = useFamilyHistory();
  const navigation =
    useNavigation<NavigationProp<FamilyHistoryStackParamList>>();

  const selected = new Set(state.ancestryHistory);

  const toggle = (id: AncestryEnum) => {
    const next = new Set(selected);
    if (next.has(id)) {
      next.delete(id);
    } else {
      next.add(id);
    }
    updateState({ ancestryHistory: Array.from(next) });
  };

  const handleNext = () => {
    navigation.navigate("DnaTest");
  };

  return (
    <QuestionLayout
      title={t("med_history.family_history.ancestry_title")}
      subtitle={t("med_history.family_history.ancestry_subtitle")}
      onBack={() => {
        // Dispatch goBack on the root navigator to exit the modal
        navigation.dispatch(CommonActions.goBack());
      }}
      onSave={handleNext}
      saveDisabled={state.ancestryHistory.length === 0}
      saveLabel={t("med_history.shared.next")}
    >
      <View style={styles.grid}>
        {ANCESTRY_OPTIONS.map((option) => (
          <View key={option.id} style={styles.cell}>
            <SquareOptionButton
              icon={option.icon}
              label={t(option.labelKey)}
              isSelected={selected.has(option.id)}
              onPress={() => toggle(option.id)}
              labelSize="sm"
            />
          </View>
        ))}
      </View>
    </QuestionLayout>
  );
}

const styles = StyleSheet.create({
  grid: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 12,
    width: "100%",
    marginBottom: 40,
  },
  cell: {
    width: "47%",
  },
});
